import { aiServiceDetailsActions } from "../actionCreators";
import { ContactsTypes } from "../../../Utils/Contacts";
import { serviceSetupStatuses } from "../../../Utils/serviceSetup";
import {
    serviceCreationStatus,
    progressStages,
    sections,
} from "../../../Pages/AiServiceCreation/constant";
import { storageTypes } from "../../../Utils/storageTypes";
import { serviceTypes } from "../../../Utils/serviceTypes";

export const defaultGroups = [
    {
        name: "default_group",
        id: "",
        pricing: [
            {
                default: true,
                priceModel: "fixed_price",
                priceInCogs: 1,
            },
        ],
        endpoints: {},
        testEndpoints: [],
        daemonAddresses: [],
        freeCallsAllowed: 3,
    },
];

const initialAiServiceDetailsState = {
    createNewAIService: false,
    demoComponentAvailable: true,
    serviceState: {
        state: serviceCreationStatus.NOT_STARTED,
    },
    touched: false,
    status: serviceSetupStatuses.NOT_STARTED,
    uuid: "",
    name: "",
    id: "",
    newId: "",
    lighthouseToken: null,
    storageProvider: storageTypes[0].id,
    availability: "",
    shortDescription: "",
    longDescription: "",
    projectURL: "",
    proto: {
        hash: "",
        encoding: "",
        type: "",
    },
    assets: {
        heroImage: {
            url: "",
            hash: "",
        },
        demoFiles: {
            url: "",
            buildId: "",
        },
        protoFiles: {
            url: "",
            hash: "",
        },
    },
    serviceType: serviceTypes.GRPC,
    contributors: "",
    hash: "",
    contacts: [
        { type: ContactsTypes.GENERAL, email: "", phone: "" },
        { type: ContactsTypes.SUPPORT, email: "", phone: "" },
    ],
    groups: defaultGroups,
    tags: [],
    comments: {
        SERVICE_PROVIDER: "",
        SERVICE_APPROVER: "<div></div>",
    },
    foundInBlockchain: false,
    progressStages,
    currentSection: sections.AI_PROFILE,
    savedPricingDetails: false,
    isHaaSUsed: false,
    deployments: {
        //from search_deployments
        orgId: "",
        serviceId: "",
        daemon: {
            id: "",
            status: "",
            daemonConfig: {
                serviceEndpoint: "",
                isServiceHosted: null,
                paymentChannelStorageType: "",
            },
            daemonEndpoint: "",
        },
        hostedService: {
            id: "",
            status: "",
            githubAccountName: "",
            githubRepositoryName: "",
            lastCommitUrl: "",
        },
        accountsMatch: null,
    },
};

const serviceDetailsReducer = (state = initialAiServiceDetailsState, action) => {
    switch (action.type) {
        case aiServiceDetailsActions.SET_CREATE_NEW_AI_SERVICE:
            return { ...state, createNewAIService: action.payload };
        case aiServiceDetailsActions.SET_DEMO_COMPONENT_AVAILABLE:
            return { ...state, demoComponentAvailable: action.payload };
        case aiServiceDetailsActions.SET_BUILD_STATUS:
            return { ...state, progressStages: action.payload };
        case aiServiceDetailsActions.SET_PROGRESS_STATUS:
            return { ...state, progressStages: action.payload };
        case aiServiceDetailsActions.SET_ALL_SERVICE_DETAILS_ATTRIBUTES:
            return { ...state, ...action.payload };
        case aiServiceDetailsActions.SET_AI_SERVICE_TOUCHED_FLAG:
            return { ...state, touched: action.payload };
        case aiServiceDetailsActions.SET_AI_SERVICE_ID:
            return { ...state, id: action.payload };
        case aiServiceDetailsActions.SET_AI_SERVICE_ID_AVAILABILITY:
            return { ...state, availability: action.payload };
        case aiServiceDetailsActions.SET_AI_SERVICE_NAME:
            return { ...state, name: action.payload };
        case aiServiceDetailsActions.SET_AI_SERVICE_UUID:
            return { ...state, uuid: action.payload };
        case aiServiceDetailsActions.SET_AI_SERVICE_GROUPS:
            return { ...state, groups: action.payload, touched: true };
        case aiServiceDetailsActions.SET_IS_HAAS_USED:
            return { ...state, isHaaSUsed: action.payload };
        case aiServiceDetailsActions.SET_AI_SERVICE_TYPE:
            return { ...state, serviceType: action.payload };
        case aiServiceDetailsActions.SET_AI_SERVICE_DETAIL_LEAF:
            return {
                ...state,
                [action.payload.name]: action.payload.value,
                touched: true,
            };
        case aiServiceDetailsActions.SET_AI_SERVICE_MULTIPLE_DETAILS:
            return { ...state, ...action.payload };
        case aiServiceDetailsActions.SET_AI_SERVICE_FREE_CALL_SIGNER_ADDRESS:
            return { ...state, freeCallSignerAddress: action.payload };
        case aiServiceDetailsActions.SET_SERVICE_PROVIDER_COMMENT:
            return {
                ...state,
                comments: {
                    ...state.comments,
                    SERVICE_PROVIDER: action.payload,
                },
            };
        case aiServiceDetailsActions.SET_AI_SERVICE_STATE_STATE:
            return { ...state, serviceState: { ...state.serviceState, state: action.payload } };
        case aiServiceDetailsActions.SET_SERVICE_DETAILS_PROTO_URL:
            return {
                ...state,
                assets: {
                    ...state.assets,
                    protoFiles: { ...state.assets.protoFiles, url: action.payload },
                },
            };
        case aiServiceDetailsActions.SET_SERVICE_HERO_IMAGE_URL:
            return {
                ...state,
                assets: {
                    ...state.assets,
                    heroImage: { ...state.assets.heroImage, url: action.payload },
                },
                touched: true,
            };
        case aiServiceDetailsActions.SET_SERVICE_DEMO_FILES_URL:
            return {
                ...state,
                assets: {
                    ...state.assets,
                    demoFiles: { ...state.assets.demoFiles, url: action.payload },
                },
                touched: true,
            };
        case aiServiceDetailsActions.SET_SERVICE_DETAILS_FOUND_IN_BLOCKCHAIN:
            return { ...state, foundInBlockchain: action.payload };
        case aiServiceDetailsActions.SET_SAVED_PRICING_DETAILS:
            return { ...state, savedPricingDetails: action.payload };
        case aiServiceDetailsActions.SET_AI_SERVICE_DEPLOYMENTS:
            return { ...state, deployments: action.payload };
        case aiServiceDetailsActions.SET_HAAS_AFFECTED_SERVICE_DETAILS: {
            return { ...state, serviceType: action.payload.serviceType };
        }
        default:
            return state;
    }
};

export default serviceDetailsReducer;
